<template>
  <div>
    <el-form
      :model="list"
      :rules="toAdRule"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%; margin: 20px auto"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="楼盘名称" prop="floorId">
            <el-select
              clearable
              placeholder="请选择"
              v-model="list.floorId"
              style="width: 245px"
            >
              <el-option
                :key="item.contentId"
                :label="item.title"
                :value="item.contentId"
                v-for="item in listByLocation"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="标题" prop="title">
            <el-input placeholder="请输入标题" v-model="list.title" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="置业经理" prop="salesmanId">
            <el-select
              clearable
              placeholder="请选择"
              v-model="list.salesmanId"
              style="width: 245px"
            >
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.id"
                v-for="item in salesmanList"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="专业荐房" prop="isZhuanyejianfang">
            <el-select
              clearable
              placeholder="请选择"
              v-model="list.isZhuanyejianfang"
              style="width: 245px"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="经纪人推荐" prop="isJingjirenjianfang">
            <el-select
              clearable
              placeholder="请选择"
              v-model="list.isJingjirenjianfang"
              style="width: 245px"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="开盘视线" prop="isKaipanshixian">
            <el-select
              clearable
              placeholder="请选择"
              v-model="list.isKaipanshixian"
              style="width: 245px"
            >
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-for="item in type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="视频" prop="videoUrl" ref="videoUrl">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <video
                v-if="list.videoUrl"
                :src="list.videoUrl"
                class="avatar"
                style="width: 150px; height: auto"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          style="margin-left: 200px"
          type="primary"
          @click="submitAdd('ruleForm')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["ChangeData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.videoUrl)
      if (this.list.videoUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false, //加载
      list: "",
      listByLocation: [],
      salesmanList: [], //置业经理
       serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      //是否轮播:
      type: [
        {
          label: "否",
          value: "0",
        },
        {
          label: "是",
          value: "1",
        },
      ],
      toAdRule: {
        floorId: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        salesmanId: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        isZhuanyejianfang: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        isJingjirenjianfang: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        videoUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        isKaipanshixian: [{ required: true, message: "内容不能为空", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.list = this.ChangeData;
    this.listAllContent();
    this.salesMan();
  },
  watch: {
    ChangeData(newVal, oldVal) {
      this.list = newVal;
    },
  },
  methods: {
    // 置业经理
    salesMan() {
      this.postAxios("/salesman/list", {
        pageNum: 0,
        pageSize: 0,
      }).then((res) => {
        this.salesmanList = res.content;
      });
    },
    listAllContent() {
      this.postAxios("/rotation/listAllContentByType", {
        page: {
          pageNum: 0,
          pageSize: 0,
        },
        q: {
          contentType: 12,
        },
      }).then((res) => {
        this.listByLocation = res.content;
      });
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    // 封面图上传成功
    upSuccess(file) {
      this.list.videoUrl = file.entity;
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/floorVideo/update", {
            floorId: this.list.floorId, 
            videoUrl: this.list.videoUrl, 
            title: this.list.title, 
            id: this.list.id, 
            salesmanId: this.list.salesmanId, 
            isZhuanyejianfang: this.list.isZhuanyejianfang,
            isJingjirenjianfang: this.list.isJingjirenjianfang, //价格
            isKaipanshixian: this.list.isKaipanshixian, //开盘日期
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>